<app-toolbar>
  <app-breadcrumbs>
  </app-breadcrumbs>
</app-toolbar>
<p-table styleClass="p-datatable-sm p-datatable-striped" *transloco="let t; read: 'ime.common.events'"
         [value]="filteredData$ | async"
         dataKey="Id"
         [loading]="loading"
         [lazy]="true"
         [lazyLoadOnInit]="false"
         [paginator]="true"
         [rows]="page.Size"
         [rowsPerPageOptions]="rowsPerPageOptions"
         [showCurrentPageReport]="true"
         [first]="page.Number * page.Size"
         [totalRecords]="page.Total"
         currentPageReportTemplate="{first} to {last} of {totalRecords}"
         stateStorage="local" stateKey="event-list-local"
         (onPage)="onPage($event)">
  <ng-template pTemplate="header" let-columns>
    <th class="w-25">
      <div class="p-d-flex p-jc-between p-ai-center">
        {{t('Description')}}
        <p-columnFilter type="text" field="Description" display="menu"></p-columnFilter>
      </div>
    </th>
    <th>
      <div class="p-d-flex p-jc-between p-ai-center">
        {{t('Source')}}
        <p-columnFilter type="text" field="Source" display="menu"></p-columnFilter>
      </div>
    </th>
    <th>
      <div class="p-d-flex p-jc-between p-ai-center">
        {{t('Category')}}
        <p-columnFilter type="text" field="Category" display="menu"></p-columnFilter>
      </div>
    </th>
    <th class="w-8">
      <div class="p-d-flex p-jc-between p-ai-center">
        {{t('Level')}}
        <p-columnFilter type="text" field="Level" display="menu"></p-columnFilter>
      </div>
    </th>
    <th>
      <div class="p-d-flex p-jc-between p-ai-center">
        {{t('Date')}}
        <p-columnFilter type="text" field="CreatedDate" display="menu"></p-columnFilter>
      </div>
    </th>
    <th>
      <div class="p-d-flex p-jc-between p-ai-center">
        {{t('Created By')}}
      </div>
    </th>
    <th class="w-8">
      <div class="p-d-flex p-jc-between p-ai-center">
        {{t('Content')}}
      </div>
    </th>
  </ng-template>
  <ng-template pTemplate="body" let-row>
    <tr>
      <td>
        {{row.Description}}
      </td>
      <td class="text-break">
        {{row.Source}}
      </td>
      <td>
        {{row.Category}}
      </td>
      <td [ngClass]="eventService.colorsByLevel[row.Level]">
        <svg viewBox="0 0 8 8" class="icon" inlineSVG="{{eventService.iconsByLevel[row.Level]}}">
        </svg>
        {{row.Level | eventLevel}}
      </td>
      <td>
        {{row.CreatedDate | date:'medium'}}
      </td>
      <td>
        {{(usersQuery.selectEntity(row.CreatedBy) | async)?.Fullname}}
      </td>
      <td>
        <button type="button" class="btn btn-sm btn-outline-primary me-1" (click)="open(row)">
          <svg viewBox="0 0 8 8" class="icon small" inlineSVG="#information-circle"></svg>
        </button>
      </td>
    </tr>
  </ng-template>
</p-table>
